import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL!;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

const isEnvPostgrestPaused = () => {
  const v = process.env.REACT_APP_DISABLE_POSTGREST || '';
  return /^(1|true|yes)$/i.test(v);
};

const isRuntimePostgrestPaused = () => {
  if (isEnvPostgrestPaused()) return true;
  try {
    return window?.localStorage?.getItem('nexus:disable_postgrest') === '1';
  } catch {
    return false;
  }
};

const guardedFetch: typeof fetch = async (input, init) => {
  let urlStr = '';
  if (typeof input === 'string') {
    urlStr = input;
  } else if (input instanceof URL) {
    urlStr = input.toString();
  } else {
    urlStr = input.url || '';
  }
  if (isRuntimePostgrestPaused() && urlStr.includes('/rest/v1/')) {
    return new Response(
      JSON.stringify({
        error: 'postgrest_paused',
        message:
          'Supabase PostgREST is temporarily paused. Set localStorage "nexus:disable_postgrest" to "0" to re-enable, or remove REACT_APP_DISABLE_POSTGREST.',
      }),
      { status: 503, headers: { 'Content-Type': 'application/json' } }
    );
  }
  return fetch(input as any, init as any);
};

export const supabase = createClient(url, anonKey, {
  global: { fetch: guardedFetch },
});
